import * as ewe from "@eyeo/webext-ad-filtering-solution";
import { syncFilters } from "./sync-filters.js";
export async function start() {
    void syncFilters();
    ewe.experiments.onChanged.addListener(async () => {
        await syncFilters();
    });
}
